
import Article from "./Article"
import AccordionTransition from "./AccordionTransition"
import stubDirectives from "../mixins/stubDirectives"

export default {
  components: {
    Article,
    AccordionTransition
  },
  mixins: [stubDirectives],
  props: {
    accordionContent: {
      type: Array,
      default: () => []
    },
    fontColor: {
      type: String,
      default: null
    },
    multiSlot: {
      type: Object,
      default: () => {}
    },
    multiSlotIndex: {
      type: Number,
      default: null
    },
    isActiveMulti: {
      type: Boolean,
      default: false
    },
    focusInverted: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      accordion: []
    }
  },
  computed: {
    isMultiSlot() {
      return this.multiSlot && Object.keys(this.multiSlot).length > 0
        ? true
        : false
    }
  },
  watch: {
    "$route.hash": function(id) {
      const indexFound = this.accordionContent.findIndex(
        item => `#${item.id}` === id
      )
      if (indexFound > -1) {
        this.showContent(indexFound)
      }
    }
  },
  mounted() {
    this.accordionSlots()
  },
  methods: {
    isAccordionOpen(isOpen) {
      return this.isMultiSlot ? this.isActiveMulti : isOpen
    },
    accordionSlots() {
      if (this.isMultiSlot) {
        this.multiSlot.index = this.multiSlotIndex
        this.accordion.push(this.multiSlot)
      } else {
        this.accordion = this.accordionContent
      }
    },
    showContent(index) {
      let itemIndex, accordion
      this.isMultiSlot
        ? (itemIndex = this.multiSlot.index)
        : (itemIndex = index)
      this.isMultiSlot
        ? (accordion = this.accordionContent)
        : (accordion = this.accordion)

      accordion.map((contentRow, i) => {
        itemIndex === i
          ? (accordion[itemIndex].open = !accordion[itemIndex].open)
          : (contentRow.open = false)
        return contentRow
      })

      if (this.isMultiSlot) {
        this.$emit("click-accordion", itemIndex)
      }
    }
  }
}
